module.exports = {
      id: "logo-badge-usage",
      viewBox: "0 0 415 421",
      url: __webpack_public_path__ + "img/icons.a0c47b73.svg#logo-badge-usage",
      toString: function () {
        return this.url;
      }
    }